<template>
	<div class="slider-view">
		<div class="slider">
			<div class="track">
				<div class="left" :style="{width: _track.left + '%'}"></div>
				<div class="right" :style="{width: _track.right + '%'}"></div>
			</div>
			<div class="knob-track">
				<movable-view ref="knob" class="knob" v-model="knob" :bounds="{left: 0, top: 0, width: 100, height: 0}" :snap="{horizontal: _snap}" />
			</div>
		</div>
	</div>
</template>

<script>
	import ViewMixin from '@/mixins/ViewMixin'

	export default {
		name: 'slider-view',
		mixins: [ViewMixin],
		data() {
			return {
				knob: {
					left: 0,
					top: 0
				}
			};
		},
		watch: {
			knob() {
				var val = this.min + ((this.knob.left / 100) * this._length);

				// Handle decimals
				val = Math.round(val * Math.pow(10, this.decimals)) / Math.pow(10, this.decimals);

				this.$emit('input', val);
			},
			value: {
				handler: function () {
					this.knob.left = this.$refs.knob.normalizeLeft(100 * ((this.value - this.min) / (this.max - this.min)));
				},
				immediate: false
			}
		},
		props: {
			value: {
				type: Number,
				default: 0
			},
			min: {
				type: Number,
				required: true
			},
			max: {
				type: Number,
				required: true
			},
			step: {
				type: Number,
				default: 1
			},
			decimals: {
				type: Number,
				default: 0
			},
			lock: {
				type: Boolean,
				default: false
			},
			ticks: {
				type: Object,
				default() {
					return null;
				},
				validator(val) {
					return {
						...{
							step: 1,
							num: null
						},
						...val
					};
				}
			},
		},
		computed: {
			_snap() {
				return 100 / this._length;
			},
			_value() {
				var c = 0.5;

				return {
					coeff: c,
					percent: 100 * c
				};
			},
			_track() {
				return {
					left: this._value.percent,
					right: 100 - this._value.percent
				};
			},
			_length() {
				return this.max - this.min;
			}
		},
		mounted() {
			this.knob.left = this.$refs.knob.normalizeLeft(100 * ((this.value - this.min) / (this.max - this.min)));
		}
	}
</script>

<style lang="scss" scoped>
	.slider-view {
		/*background-color: yellow;*/

		& > .slider {
			height: 16px;
			width: 100%;
			position: relative;

			& > .track {
				overflow: hidden;
				height: 6px;
				border-radius: 3px;
				position: absolute;
				left: 5px;
				right: 5px;
				top: 5px;

				& > .left, & > .right {
					height: 100%;
					position: absolute;
					top: 0;
				}

				& > .left {
					left: 0;
					background-color: blue;
				}

				& > .right {
					right: 0;
					background-color: red;
				}
			}
			
			& > .knob-track {
				position: absolute;
				left: 0;
				top: 0;
				height: 100%;
				right: 16px;

				& > .knob {
					width: 16px;
					height: 16px;
					background-color: #39f;
					border-radius: 50%;
					position: absolute;
					top: 0;
				}
			}
		}
	}
</style>